(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-add-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('psf-sticky-buy-box')) {
    customElements.define('psf-sticky-buy-box', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => {
          this.initFrame = 0;
          if (this.isConnected) this.initialize();
        });
      }

      initialize() {
        this.productInfo = document.getElementById(`ProductInfo-${this.dataset.sectionId}`);
        this.link = this.querySelector('.psf-sticky-buy-box__button');
        if (!this.productInfo || !this.link) return;

        this.header = document.querySelector('.section-header');
        this.footer = document.querySelector('footer.footer, footer');
        this.editorSelected = false;
        this.frame = 0;
        this.events = new AbortController();
        const { signal } = this.events;

        this.scheduleUpdate = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.updateVisibility();
          });
        };

        window.addEventListener('scroll', this.scheduleUpdate, { passive: true, signal });
        window.addEventListener('resize', this.scheduleUpdate, { passive: true, signal });
        window.addEventListener('pageshow', this.scheduleUpdate, { signal });
        window.addEventListener('load', this.scheduleUpdate, { signal });
        this.link.addEventListener('click', (event) => this.returnToBuyBox(event), { signal });

        if (window.Shopify?.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            this.editorSelected = event.detail.blockId === this.dataset.blockId;
            this.scheduleUpdate();
          }, { signal });
          document.addEventListener('shopify:block:deselect', (event) => {
            if (event.detail.blockId !== this.dataset.blockId) return;
            this.editorSelected = false;
            this.scheduleUpdate();
          }, { signal });
        }

        this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
        this.resizeObserver.observe(this.productInfo);
        if (this.header) this.resizeObserver.observe(this.header);
        this.resizeObserver.observe(document.body);
        this.scheduleUpdate();
      }

      disconnectedCallback() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
        if (this.initFrame) cancelAnimationFrame(this.initFrame);
        if (this.frame) cancelAnimationFrame(this.frame);
        this.initFrame = 0;
        this.frame = 0;
      }

      headerOffset(reserveHeight = false) {
        if (!this.header) return 0;
        const position = getComputedStyle(this.header).position;
        if (position !== 'sticky' && position !== 'fixed') return 0;
        const rect = this.header.getBoundingClientRect();
        return reserveHeight ? rect.height : Math.max(0, Math.min(rect.bottom, rect.height));
      }

      updateVisibility() {
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        const enabled = this.dataset[mobile ? 'mobile' : 'desktop'] !== 'false';
        const trigger = this.productInfo.querySelector('.buy-button-wrapper, .product-form__buttons');
        const hasBuyBox = trigger && trigger.getClientRects().length > 0;
        const passedBuyBox = hasBuyBox && trigger.getBoundingClientRect().bottom <= this.headerOffset();
        const reachedFooter = this.footer && this.footer.getBoundingClientRect().top < window.innerHeight;
        const visible = enabled && hasBuyBox && (this.editorSelected || (passedBuyBox && !reachedFooter));
        this.toggleAttribute('data-visible', Boolean(visible));
        this.link.tabIndex = visible ? 0 : -1;
      }

      returnToBuyBox(event) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = this.productInfo.querySelector('main-product-form, product-form') || this.productInfo;
        if (!target.isConnected) return;
        event.preventDefault();
        const gap = Number(this.dataset.scrollGap) || 0;
        const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - this.headerOffset(true) - gap);
        const previousTabindex = target.getAttribute('tabindex');
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        target.addEventListener('blur', () => {
          if (previousTabindex === null) target.removeAttribute('tabindex');
          else target.setAttribute('tabindex', previousTabindex);
        }, { once: true });
        window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
